<template>
    <div class="tw-flex-1 tw-bg-primary h-full tw-py-14 md:tw-py-32">
        <div class="tw-container tw-mx-auto">
            <div
                class="tw-grid-gap"
                :class="activeQuestion.image ? 'tw-grid tw-grid-cols-12 tw-justify-center tw-items-center' : 'tw-flex tw-justify-center'"
            >
                <template v-if="finishedQuestions">
                    <div
                        class="tw-gap-4 max-lg:tw-gap-y-10 tw-grid tw-grid-gap tw-grid-cols-12 tw-justify-center tw-items-center"
                    >
                        <div class="tw-col-span-12 lg:tw-col-span-7 tw-bg-white tw-rounded-4xl tw-p-6 lg:tw-p-10">
                            <div class="tw-text-6xl tw-text-primary tw-font-semibold tw-flex tw-items-center tw-gap-1 tw-mb-4">
                                {{ Math.round(((correctCount / questions.length) * 100)) }}
                                <span class="tw-text-2xl">%</span>
                            </div>
                            <div class="tw-w-full tw-h-3 tw-rounded-full tw-bg-gradient-to-r tw-from-[#D96154] tw-via-[#E08C5B] tw-via-[#E7BC63] tw-via-[#EDE569] tw-to-[#9AC918] tw-relative tw-mb-12">
                                <div
                                    class="tw-absolute tw-h-full tw-right-0 tw-bg-[#F2F2F2] tw-rounded-r-full"
                                    :style="'width: ' + (100 - ((correctCount / questions.length) * 100)).toFixed(2) + '%'"
                                ></div>
                                <div
                                    class="tw-absolute tw-top-0 tw-translate-x-1/2 -tw-translate-y-full"
                                    :style="'right: ' + (100 - ((correctCount / questions.length) * 100)).toFixed(2) + '%'"
                                >
                                    <i class="fa fa-chevron-down"></i>
                                </div>
                            </div>
                            <p class="tw-prose tw-font-medium">
                                Dank voor het maken van de test. Hierboven zie je het percentage antwoorden dat je goed hebt beantwoord.<br>
                                Wil je weten hoe je voor jouw situatie de schade van Q-organismen kunt voorkomen? Maak dan een risico-analyse voor jouw situatie (je moet hiervoor wel ingelogd zijn op mijn fytocompass).
                            </p>
                            <div class="tw-flex tw-flex-wrap tw-gap-4">
                                <a href="https://fytocompass.nl/frie-vragenlijsten" target="_blank" rel="noopener noreferrer" class="tw-button">Risicoanalyse downloaden</a>
                                <a v-if="false" href="#" class="tw-button tw-button--secondary">Bekijk resultaten</a>
                            </div>
                        </div>
                        <div class="tw-col-span-12 lg:tw-col-span-5 tw-bg-white tw-rounded-4xl tw-p-6 lg:tw-p-10">
                            <h2 class="!tw-text-primary !tw-text-2xl">Vier tips om de risico’s te verkleinen:</h2>
                            <ul class="tw-space-y-4 tw-pl-0 tw-mb-0">
                                <li class="tw-flex tw-items-center tw-gap-4">
                                    <i class="fa fa-check-circle tw-text-primary-300"></i>
                                    Weet waar je (plant)materiaal vandaan komt.
                                </li>
                                <li class="tw-flex tw-items-center tw-gap-4">
                                    <i class="fa fa-check-circle tw-text-primary-300"></i>
                                    Wees alert op schade aan bast, boom, wortel of blad.
                                </li>
                                <li class="tw-flex tw-items-center tw-gap-4">
                                    <i class="fa fa-check-circle tw-text-primary-300"></i>
                                    Meld een vondst altijd bij de NVWA.
                                </li>
                                <li class="tw-flex tw-items-center tw-gap-4">
                                    <i class="fa fa-check-circle tw-text-primary-300"></i>
                                    Ken de waardplanten en risicogebieden van Q-organismen die relevant zijn voor jouw bedrijf.
                                </li>
                            </ul>
                        </div>
                    </div>
                </template>
                <template v-else>
                    <div
                        class="tw-flex tw-items-center"
                        :class="activeQuestion.image ? 'tw-col-span-12 lg:tw-col-span-7' : 'max-w-2xl'"
                    >
                        <div>
                            <div class="tw-text-sm tw-text-white" v-if="!finishedQuestions">{{ activeQuestionIndex + 1 }}/{{ questions.length }}</div>
                            <div class="tw-my-4 tw-h-1.5 tw-bg-white/20 tw-rounded-full tw-w-full tw-relative">
                                <div class="tw-absolute tw-h-full tw-bg-primary-300 tw-rounded-full" :style="'width: ' + (activeQuestionIndex + 1) / questions.length * 100 + '%'"></div>
                            </div>

                            <organisms-question
                                show-next-button
                                :question="activeQuestion"
                                :is-last-question="isLastQuestion"
                                @event:next="nextQuestion"
                            />
                        </div>
                    </div>
                    <div v-if="activeQuestion.image" class="tw-col-span-12 lg:tw-col-span-5 lg:tw-flex tw-justify-end tw-items-center">
                        <img
                            v-if="activeQuestion.image"
                            :src="activeQuestion.image"
                            :alt="activeQuestion.title"
                            class="tw-w-80 tw-h-80 tw-object-cover tw-rounded-4xl"
                        >
                    </div>
                </template>
            </div>
        </div>
    </div>
</template>

<script>
import OrganismsQuestion from './OrganismsQuestion';
export default {

  components: {OrganismsQuestion},
  props: {
    questions: {
      type: Object,
      required: true,
    },
  },
  data: () => ({
    activeQuestionIndex: 0,
    correctCount: 0,
    finishedQuestions: false,
  }),
  computed: {
    activeQuestion() {
      return this.questions[this.activeQuestionIndex];
    },
    isLastQuestion() {
      return this.activeQuestionIndex + 1 === this.questions.length;
    },
  },
  methods: {
    nextQuestion(correctAnswer) {
      if (correctAnswer) {
        this.correctCount++;
      }

      if (this.isLastQuestion) {
        this.finishedQuestions = true;

        return;
      }

      this.activeQuestionIndex++;
    },
  },
};
</script>
